import { render, staticRenderFns } from "./UserPicker.vue?vue&type=template&id=1bb39537&scoped=true&"
import script from "./UserPicker.vue?vue&type=script&lang=js&"
export * from "./UserPicker.vue?vue&type=script&lang=js&"
import style0 from "./UserPicker.vue?vue&type=style&index=0&id=1bb39537&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb39537",
  null
  
)

export default component.exports